import * as React from "react";

import * as styledComponents from "./container.module.scss";

const Container = ({ children }) => {
  return <div className={styledComponents.container}>{children}</div>;
};

export default Container;
